import React from "react";
import { format, utcToZonedTime } from "date-fns-tz";
import "./publish-details.m.css";

export const getTimeStamp = (date, template, timezone = "Asia/Dubai") => {
  if (timezone && template === "story") {
    const zonedTime = timezone && utcToZonedTime(date, timezone);
    const formatZonedTime = zonedTime && format(zonedTime, "MMMM dd, yyyy | HH:mm", { timezone: timezone });
    return <time dateTime={formatZonedTime}>{formatZonedTime}</time>;
  }
};

export default function PublishDetails({ story, template, timezone }) {
  const lastPublishedTime = story?.["last-published-at"];
  return <div styleName="last-updated">Last updated: {getTimeStamp(lastPublishedTime, template, timezone)}</div>;
}
